'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('agreementsCtrl', agreementsCtrl);

  agreementsCtrl.$inject = ['onboardingRouter', '$rootScope', 'user', 'agreementsSvc', '$translate', 'NotifyingSvc', 'isSkipFeatureEnabled'];

  function agreementsCtrl(onboardingRouter, $rootScope, user, agreementsSvc, $translate, NotifyingSvc, isSkipFeatureEnabled) {
    var vm = this;
    vm.isProfileComplete = user.isProfileComplete;
    vm.acceptedAgreements = [];
    vm.userId = user.id;
    vm.isSkipFeatureEnabled = isSkipFeatureEnabled;
    vm.agreements = [];

    activate();

    function activate() {
      if (vm.isSkipFeatureEnabled) {
        onboardingRouter.goToNextStep();
      }

      agreementsSvc.getAgreements().then(function (resp) {
        vm.agreements = resp;
        if (!vm.agreements.length) {
          onboardingRouter.goToNextStep();
        }
      });

      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.GET_AGREEMENTS, true);
    }

    vm.getTranslation = function (key) {
      return $translate.instant('onboarding.account.checkboxTerms.titles.' + key);
    };

    vm.isDisabled = function () {
      return !vm.form.$valid;
    };

    vm.save = function () {
      vm.agreements.forEach(function (agreement) {
        agreement.userId = vm.userId;
      });

      agreementsSvc.saveAgreements(vm.agreements);

      // Webview post message
      if ($rootScope.isMobileWebView) {
        $rootScope.sendWebViewPostMessage('agreements');
      }

      onboardingRouter.goToNextStep();
    };
  }
})();